import React from "react";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";
import { ContextualMenu } from "@common/contextualMenu";
import { Props } from "./types";

function capitalize(useCase: UseCases) {
  return useCase[0].toUpperCase() + useCase.slice(1);
}

function useCaseToPermission(useCase: UseCases) {
  return `can${capitalize(useCase)}`;
}

function SecureContextualMenu(props: Props) {
  return (
    <Safeguard
      useCases={Array.from(
        new Set(
          props.items.reduce<UseCases[]>(
            (acc, item) => [
              ...acc,
              ...("useCases" in item ? item.useCases : [item.useCase]),
            ],
            [],
          ),
        ),
      )}
      context={props.context}
    >
      {(permissions) => {
        const filteredItems = props.items.filter((item) =>
          "useCases" in item
            ? item.useCases.some(
                (useCase) =>
                  !!permissions[
                    useCaseToPermission(useCase) as keyof typeof permissions
                  ],
              )
            : !!permissions[
                useCaseToPermission(item.useCase) as keyof typeof permissions
              ],
        );

        return filteredItems.length > 0 ? (
          <ContextualMenu
            items={filteredItems}
            className={props.className}
            openedClassName={props.openedClassName}
          />
        ) : (
          props.replacement || <React.Fragment />
        );
      }}
    </Safeguard>
  );
}

export { SecureContextualMenu };
